import { Keyboard } from "react-native";
import { toogleLoading } from "../../store/slices/PolicySlice";
import { useAppDispatch } from "../../store/Store";
import { introspectionAPI } from "../user";
import { messages } from "../../../src/resources/strings";
import { resetPasswordApi } from "../password";

const resetPasswordHandler = ({
  setErrorMessage,
  passwordObj,
  setPasswordResetSuccess,
}: {
  passwordObj: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  };
  setErrorMessage: (data: string) => void;
  setPasswordResetSuccess: (data: boolean) => void;
}) => {
  const dispatch = useAppDispatch();

  const setLoading = (loading: boolean) => {
    dispatch(toogleLoading(loading));
  };

  const callResetPasswordAPIandUpdateResponse = async () => {
    Keyboard.dismiss();
    setLoading(true);
    const obj = {
      currentPassword: passwordObj.currentPassword,
      password: passwordObj.newPassword,
      confirmPassword: passwordObj.confirmPassword,
    };
    const responseObj = await resetPasswordApi(obj);
    if (responseObj.errorCode == messages.error.noError) {
      setPasswordResetSuccess(true);
      setErrorMessage(responseObj.errorCode);
    } else if (responseObj.errorCode == messages.error.callAgainAPI) {
      callResetPasswordAPIandUpdateResponse();
      setErrorMessage(responseObj.errorCode);
    } else if (responseObj.errorCode) {
      setErrorMessage(responseObj.errorCode);
    }
    setLoading(false);
  };

  const callIntrospectionAndResetPasswordApi = async () => {
    const introspectionResponse = await introspectionAPI();
    if (introspectionResponse.response) {
      callResetPasswordAPIandUpdateResponse();
    } else {
      setErrorMessage(messages.error.resetPasswordLogout);
    }
  };

  return { resetPassword: callIntrospectionAndResetPasswordApi };
};

export default resetPasswordHandler;
